export default __webpack_public_path__ + "static/media/tennis-firstServe-featured.35eb300e.png";